// ABOUTME: Animated loading indicator sized and colored by its props
// ABOUTME: Renders nothing inside its box until the optional delay elapses, so fast loads never flash it
import * as React from 'react';
import { useEffect, useState } from 'react';
import Animation from './Animation';
import { LoadingIndicatorProps } from './Types';

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  type,
  color,
  height,
  width,
  delay,
  className,
}) => {
  const [delayed, setDelayed] = useState(delay > 0);

  useEffect(() => {
    if (delay <= 0) {
      return;
    }
    const timeout = setTimeout(() => setDelayed(false), delay);
    return () => clearTimeout(timeout);
  }, [delay]);

  return (
    <div className={className} style={{ fill: color, height, width }}>
      {delayed ? <></> : <Animation type={type} />}
    </div>
  );
};

export default LoadingIndicator;
